import { createFileRoute } from '@tanstack/react-router';
import { getAuthtoken, getSelectedOrganizationId } from 'stores/useAuthStore';
import ScheduledTasks from 'containers/ScheduledTasks';
import { scheduledTasksQueryOptions } from 'containers/ScheduledTasks/useScheduledTasks';

export const Route = createFileRoute('/_authenticated/scheduledTasks')({
  loader: ({ context }) => {
    const authToken = getAuthtoken();
    const organizationId = getSelectedOrganizationId();
    return context.queryClient.prefetchQuery(
      scheduledTasksQueryOptions(authToken, organizationId)
    );
  },
  component: ScheduledTasks,
});
